module.exports = "../../app/cells/pages/rankings/subscriptions/show/hero_cell.rb";